import React, { Component } from 'react';

import Button from '../../components/UI/Button/Button';
import AttachFilePreview from './AttachFilePreview';
import Icon from '../../components/UI/Icon/Icon';
import './AttachFile.css';
import MediaQuery from 'react-responsive';
import ConsoleLog from './../../hoc/ConsoleLog/ConsoleLog';

class AttachFile extends Component {
  state = {
    fileList: [],
    hoverState:'',
    errorMessage:''
  };

  componentWillMount() {
    //ConsoleLog('will mount selectedFiles', this.props.selectedFiles);
    const NewFileList = this.props.selectedFiles ? this.props.selectedFiles.split(';') : '';
    if(NewFileList.length) {
      let files = [];
      NewFileList.map((file, index) => {
        files[index] = {};
        const fileDetail = file.split('/');
        files[index].name = fileDetail.slice(-1);
      });
      this.setState({fileList:files});
    }
  }

  componentDidUpdate(nextProps) {
    const existingFile = this.state.fileList.filter((file)=> {
      return this.props.selectedFiles.includes(file.name);
    });
    ConsoleLog("existingFile",existingFile)
    if(existingFile.length===0) {
      ConsoleLog("componentDidUpdate atach",this.props.selectedFiles)
      const NewFileList = this.props.selectedFiles ? this.props.selectedFiles.split(';') : '';
      if(NewFileList.length) {
        let files = [];
        NewFileList.map((file, index) => {
          files[index] = {};
          const fileDetail = file.split('/');
          files[index].name = fileDetail.slice(-1);
        });
        this.setState({fileList:files});
      }
    }
  }


  /**
  * @desc handling draging file in file upload
  * @param event
  * @return null
  */
  handleDragOver = (e) =>  {
    if ('preventDefault' in e) {
      e.stopPropagation();
      e.preventDefault();
    }

    const hoverState = (e.type === 'dragover') ? "hover" : null;
    this.setState({
      hoverState
    })
  }

  /**
  * @desc handling file select event in file upload
  * @param event
  * @return null
  */
  handleFileSelect = (e) => {

    this.handleDragOver(e);
    let files = e.target.files || e.dataTransfer.files;
    let fileList = [...this.state.fileList];
    let fileNames = fileList.map(file=> { return file.name.toString() })
    let NewFileList = Object.keys(files).map(file => files[file]); 
    let errorMessage = "";
    NewFileList.map(file=>{
        if(file && (file.size > this.props.maxSize)) {
          errorMessage = "File size exceeded.";
        }
        else if(fileNames.includes(file.name)) {
          errorMessage = "File already exists.";
        }
        else if(!this.props.DragAcceptedTypes.includes(file.type)) {
          errorMessage = "Please select valid file format.";
        }
        else {
          fileList =  fileList.concat(file);
          //ConsoleLog("fileList",fileList)
          this.props.handleFileSelect(file);
        }     
    })
    this.setState({
      fileList,
      errorMessage
    });

  }

  /**
  * @desc Removing the selected file.
  * @param index
  * @return null
  */
  removeItem = (index) => {
    //ConsoleLog("removeItem1",index,this.state.fileList);
    let fileList = this.state.fileList;
    let file = (fileList.length)? fileList[index].name : null;
    fileList.splice(index,1);
    this.props.handleFileRemove(file);
    this.setState({
      fileList,
      errorMessage:''
    });
  }

  removeFile = ()=> {
    // ConsoleLog("removeFile")
    this.setState({
      fileList:[]
    });
  }

  /**
  * @desc preview for the file upload.
  * @param null
  * @return null
  */
  previews = () => {
    return this.state.fileList.map((file, index) => {     
      const isUploadedFile = this.props.selectedFiles.includes(file.name);
      return (
        <AttachFilePreview key={index} data={file} onRemove={()=>this.removeItem(index)} progressPercent={this.props.progressPercent} isUploadedFile={isUploadedFile}/>
      );
    });
  }

  /**
  * @desc Selecting the file to be uploaded
  * @param event
  * @return null
  */
  selectFile = (e) => {
    e.preventDefault();
    this.input.click(e);
    this.props.onclickAttach();
  }

  /**
  * @desc Rendering the DOM element 
  * @param null
  * @return DOM element
  */
  render() {
    let {
      maxSize,
      name,
      multiple,
      label,
      acceptedTypes,
      buttonText,
      dropZoneText,
      className
    } = this.props;
  
    return (
      <div className="attach-file-container">
          <input type='hidden' name={`${name}:maxSize`} value={maxSize} />
          <div>
          <MediaQuery query="(max-device-width: 767px)">
            <div className="file-drag" onClick={this.selectFile}>                
                <div className="dropzone-message">
                    <span>
                        <Icon icon="upload-icon" className="dropzone-icon"/>
                        <span className="dropzone-text">Upload your documents here</span><br></br>
                        <span className="dropzone-info">Max file size should be 5MB |  File types should be .doc .ppt .pdf .png .jpeg .gif</span>
                        {this.state.errorMessage?<span className="attach-file-error">{this.state.errorMessage}</span>:""}
                        <br/>
                    </span>
                </div>              
            </div>
          </MediaQuery>
          <MediaQuery query="(min-device-width: 768px)">
            <div className="file-drag"
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragOver}
                onDrop={this.handleFileSelect}
                onClick={this.selectFile}
            >                
              <div className="dropzone-message" >
                <span>
                  <span className="drop-zone-icon-span" ><Icon icon="upload-icon" className="dropzone-icon"/></span>
                  <span className="dropzone-text">You can browse or drop files here</span>
                  <br></br>
                  <span className="dropzone-info">Max file size should be 5MB |  File types should be .doc .ppt .pdf .png .jpeg .gif</span>
                  {this.state.errorMessage?
                  <span className="attach-file-error">{this.state.errorMessage}</span>:""}
                  <br/>
                </span>
              </div>              
            </div>
            </MediaQuery>
           {this.state.fileList&&this.state.fileList.length>0? <div className="dropzone-preview">{this.previews()}</div>:""}
            <div className="upload-button-input">
              <input 
                type='file'
                tabIndex='-1'
                ref={x => this.input = x}
                className="input-file-upload"
                name={name} 
                multiple={multiple}
                size={maxSize}
                accept={acceptedTypes}
                onChange={this.handleFileSelect}
                onClick={(e)=> { e.target.value = null }}/>

              {/* <Button 
                className="attach-file-button"
                type='button'
                onClick={this.selectFile}>
                {buttonText}
              </Button> */}
            </div>
          </div>
      </div>
    );
  }
}

export default AttachFile;


// WEBPACK FOOTER //
// ./src/hoc/AttachFile/AttachFile.js